import React from "react";
import { Button, Box, Typography } from "@mui/material";

export const ExcelForm = () => {
  /* Excel dosyasının kullanıcı bilgisayarına yüklenmesini sağlayan function */
  const handleDownloadProduct = () => {
    const fileUrl = "/excel/ProductUpload.xlsx";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "ProductUpload.xlsx";
    link.click();
  };
  const handleDownloadStockAndPrice = () => {
    const fileUrl = "/excel/StockAndPriceUpdate.xlsx";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "StockAndPriceUpdate.xlsx";
    link.click();
  };

  return (
 

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        p: { xs: 2, sm: 3, md: 4 },
        background: "#F7F9FC",
        borderRadius: { xs: 2, sm: 3, md: 5 },
        width: { xs: "95%", sm: "85%", md: "70%" },
        maxWidth: "600px",
        mx: "auto",
      }}
      >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: "bold",
          color: "#1F1B45",
          mb: { xs: 2, sm: 3, md: 4 },
          textAlign: "center",
          fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" },
          px: { xs: 1, sm: 2 },
        }}
      >
        Excel Dosyası İndirme ve Yükleme
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "#555",
          textAlign: "center",
          mb: { xs: 2, sm: 3, md: 4 },
          fontSize: { xs: "0.875rem", sm: "1rem" },
          px: { xs: 1, sm: 2 },
          lineHeight: 1.5,
        }}
      >
        Lütfen örnek Excel dosyasını indirerek, verilerinizi doğru formatta
        yükleyin. Excel dosyasını güncelledikten sonra sisteme geri
        yükleyebilirsiniz.
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "#555",
          textAlign: "center",
          mb: { xs: 1, sm: 1.5 },
          fontSize: { xs: "0.875rem", sm: "1rem" },
          fontWeight: 500,
        }}
      >
        Örnek excel dosyası indir
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1.5, sm: 2 },
          justifyContent: "center",
          width: "100%",
          px: { xs: 1, sm: 2 },
        }}
      >
        <Button
          variant="contained"
          onClick={handleDownloadProduct}
          fullWidth={window.innerWidth < 600}
          sx={{
            backgroundColor: "#1F1B45",
            color: "white",
            fontWeight: "500",
            textTransform: "none",
            padding: { xs: "8px 16px", sm: "10px 20px" },
            borderRadius: { xs: "8px", sm: "10px" },
            fontSize: { xs: "0.875rem", sm: "1rem" },
            boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
            minWidth: { xs: "100%", sm: "auto" },
            "&:hover": {
              backgroundColor: "#2C285A",
              boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              transform: "translateY(-1px)",
              transition: "all 0.2s ease-in-out",
            },
            "&:active": {
              transform: "translateY(0)",
              boxShadow: "0 2px 4px rgba(31, 27, 69, 0.3)",
            },
          }}
        >
          Ürün Yükleme
        </Button>
        <Button
          variant="contained"
          onClick={handleDownloadStockAndPrice}
          fullWidth={window.innerWidth < 600}
          sx={{
            backgroundColor: "#1F1B45",
            color: "white",
            fontWeight: "500",
            textTransform: "none",
            padding: { xs: "8px 16px", sm: "10px 20px" },
            borderRadius: { xs: "8px", sm: "10px" },
            fontSize: { xs: "0.875rem", sm: "1rem" },
            boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
            minWidth: { xs: "100%", sm: "auto" },
            "&:hover": {
              backgroundColor: "#2C285A",
              boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              transform: "translateY(-1px)",
              transition: "all 0.2s ease-in-out",
            },
            "&:active": {
              transform: "translateY(0)",
              boxShadow: "0 2px 4px rgba(31, 27, 69, 0.3)",
            },
          }}
        >
          Stok ve fiyat güncelleme
        </Button>
      </Box>
    </Box>
  
  );
};
